"use client";
import * as Dialog from "@radix-ui/react-dialog";
import { BaseModalHeader, BaseModalHeaderV2 } from "./BaseModalHeader";
import { BaseModalFooter } from "./BaseModalFooter";
import { BaseModalContent } from "./BaseModalContent";
import { BaseModalBackHeader } from "./BaseModalBackHeader";
import "./BaseModal.scss";
import clsx from "clsx";
import React from "react";

type BaseModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  overrideClassNames?: string;
  overrideBaseModalClassName?: string;
  id?: string;
  role?: string;
  stacked?: boolean;
  children: React.ReactNode;
};

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use the new modal system instead.
 */
const BaseModal = ({
  open,
  setOpen,
  overrideClassNames,
  stacked = false,
  overrideBaseModalClassName = "ui-base-modal-overlay",
  id = undefined,
  role = "dialog",
  children,
}: BaseModalProps) => {
  const WrapperComponent = stacked ? "div" : React.Fragment;
  return (
    <WrapperComponent {...(stacked && { onPointerDownCapture: (e) => { e.stopPropagation() } })}>
      <Dialog.Root open={open} onOpenChange={setOpen} modal={!stacked}>
        <Dialog.Portal>
          {!stacked && (
            <Dialog.Overlay className={overrideBaseModalClassName} />
          )}
          {stacked && (
            <div className={clsx(overrideBaseModalClassName, "stacked-modal-overlay")} />
          )}
          <Dialog.Content
            className={clsx(
              "bg-white shadow br-x4 ui-base-modal-body",
              { "stacked-modal-body": stacked },
              overrideClassNames
            )}
            id={id}
            role={role}
          >
            {children}
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </WrapperComponent>
  );
};

BaseModal.Header = BaseModalHeader;
BaseModal.HeaderV2 = BaseModalHeaderV2;
BaseModal.HeaderBack = BaseModalBackHeader;
BaseModal.Content = BaseModalContent;
BaseModal.Footer = BaseModalFooter;

export { BaseModal };
